import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { StepBreadcrumbComponent, StepBreadcrumbItem } from '../../shared/components/step-breadcrumb/step-breadcrumb.component';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PoModalComponent, PoModalModule, PoPageModule, PoLoadingModule } from '@po-ui/ng-components';
import { LooseHeaderComponent } from './loose-header/loose-header.component';
import { LooseConferenceComponent } from './loose-conference/loose-conference.component';
import { ModalTerminalSelectComponent } from '../../modal-terminal-select/modal-terminal-select.component';

@Component({
  selector: 'app-loose',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    PoModalModule,
    PoPageModule,
    PoLoadingModule,
    LooseHeaderComponent,
    LooseConferenceComponent,
    ModalTerminalSelectComponent,
    StepBreadcrumbComponent
  ],
  templateUrl: './loose.component.html',
  styleUrl: './loose.component.css'
})
export class LooseComponent implements OnInit {
  @ViewChild('modalTerminalSelect') modalTerminalSelect!: PoModalComponent;
  loading = false;
  showConference = false;
  conferenceParams: any = null;

  readonly breadcrumbs: StepBreadcrumbItem[] = [
    { label: 'Home', id: '/home' },
    { label: 'Contagem Avulsa', id: '/avulsa' }
  ];

  orderCountStep = 1;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      // Se houver parâmetros de conferência, mostra o componente de conferência
      this.showConference = !!(params['branchCode'] && params['countCode']);
      if (this.showConference) {
        this.conferenceParams = params;
      }
      this.cdr.detectChanges();
    });
  }

  navigateBreadcrumb(event: { item: StepBreadcrumbItem; index: number }) {
    if (event.item.id) {
      this.router.navigate([event.item.id]);
    }
  }

  onLoading(event: boolean) {
    this.loading = event;
  }

  onTerminalModalOpen() {
    this.modalTerminalSelect.open();
  }
}
